import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useOrg } from '../contexts/OrgContext';

export default function ProtectedRoute() {
  const { user, loading: authLoading } = useAuth();
  const { membership, loading: orgLoading } = useOrg();

  if (authLoading || orgLoading) {
    return (
      <div className="min-h-screen bg-gray-900 flex items-center justify-center">
        <div className="text-orange-500 text-lg font-semibold animate-pulse">GroundCheck</div>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  if (!membership) return <Navigate to="/setup" replace />;

  return <Outlet />;
}
